import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllAdminData } from '../store/admin';
// Non-admin thunks
import { fetchAccountsUser } from '../store/accounts';
import { fetchBuildingsUser } from '../store/buildings';
import { fetchCompaniesUser } from '../store/companies';
import { fetchTrailersUser } from '../store/trailers';
import { fetchTrucksUser } from '../store/trucks';
import { fetchUsersUser } from '../store/users';
import { fetchYardsUser } from '../store/yards';

export const useLoadAppData = () => {
  const dispatch = useDispatch();
  const sessionUser = useSelector(state => state.session.user);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        if (sessionUser?.is_admin) {
          // Admin users load all data
          await dispatch(fetchAllAdminData());
        } else if (sessionUser) {
          // Non-admin users load only data related to their account
          await dispatch(fetchAccountsUser(sessionUser.account_id));
          await dispatch(fetchCompaniesUser(sessionUser.account_id));
          await dispatch(fetchUsersUser(sessionUser.account_id));
          await dispatch(fetchTrucksUser(sessionUser.account_id));
          await dispatch(fetchTrailersUser(sessionUser.account_id));
          await dispatch(fetchBuildingsUser(sessionUser.account_id));
          await dispatch(fetchYardsUser(sessionUser.account_id));
        }
      } catch (error) {
        console.error('Error loading data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    if (sessionUser) {
      loadData();
    }
  }, [dispatch, sessionUser]);

  return isLoading;
};
